<div class="modal-header border-0 app-turqiz-bg app-white-text">
  <div translate>Request for Quotation</div>
  <button type="button" class="close" aria-label="{{'Close'|translate}}" [mat-dialog-close]="true"
    (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body rfq-modal">
  @if (isLoaded) {
    <div class="alert alert-secondary">Product: {{data.skuText || data.sku}}</div>
    <form [formGroup]="form" (ngSubmit)="submitForm()" focusInvalidInput>
      <div class="row mx-md-n4">
        @if (user.isGuest()) {
          <ng-container formGroupName="user">
            <div class="form-group col-6 px-md-4"
              [ngClass]="{'has-danger': form.get('user').get('first_name').touched && form.get('user').get('first_name').errors}">
              <label class="form-control-label" [ngClass]="{'required': true}" translate>First name</label>
              <input type="text" class="form-control" name="first_name" formControlName="first_name"
                [ngClass]="{'form-control-danger': form.get('user').get('first_name').touched && form.get('user').get('first_name').errors, 'form-control-success': form.get('user').get('first_name').touched && form.get('user').get('first_name').valid}">
              <div aria-live="polite" role="log">
                @if (form.get('user').get('first_name').touched && form.get('user').get('first_name').errors ) {
                  <small
                    class="form-control-feedback text-danger" translate>Please enter a valid first name
                  </small>
                }
              </div>
            </div>
                    <div class="form-group col-6 px-md-4" [ngClass]="{'has-danger': form.get('user').get('last_name').touched &&
                      form.get('user').get('last_name').errors}">
              <label class="form-control-label" [ngClass]="{'required':  true}" translate>User Last Name
              </label>
                        <input type="text" class="form-control" name="last_name" formControlName="last_name" [ngClass]="{'form-control-danger': form.get('user').get('last_name').touched &&
                            form.get('user').get('last_name').errors}">
              <div aria-live="polite" role="log">
                @if (form.get('user').get('last_name').touched && form.get('user').get('last_name').errors) {
                  <small
                    class="form-control-feedback text-danger" translate>Please enter a valid last name
                  </small>
                }
              </div>
            </div>
                    <div class="form-group col-6 px-md-4" [ngClass]="{'has-danger': form.get('user').get('user_email').touched &&
                     form.get('user').get('user_email').errors}">
              <label class="form-control-label" [ngClass]="{'required': true}" translate>User Email</label>
              <input type="email" class="form-control" name="user_email" formControlName="user_email"
                            [ngClass]="{'form-control-danger': form.get('user').get('user_email').touched &&
                           form.get('user').get('user_email').errors}">
              <div aria-live="polite" role="log">
                @if (form.get('user').get('user_email').touched && form.get('user').get('user_email').errors) {
                  <small
                    class="form-control-feedback text-danger" translate>Please enter a valid email
                  </small>
                }
              </div>
            </div>
                    <div class="form-group col-6 px-md-4" [ngClass]="{'has-danger': form.get('user').get('user_phone').touched &&
                     form.get('user').get('user_phone').errors}">
              <label class="form-control-label" [ngClass]="{ 'required': true}" translate>User Phone</label>
              <input type="text" class="form-control " name="user_phone" formControlName="user_phone"
                            [ngClass]="{'form-control-danger': form.get('user').get('user_phone').touched &&
                           form.get('user').get('user_phone').errors && form.get('user').get('user_phone').errors?.pattern}">
              <div aria-live="polite" role="log">
                @if (form.get('user').get('user_phone').touched && form.get('user').get('user_phone').errors) {
                  <small
                    class="form-control-feedback text-danger" translate>Please enter a valid Phone number
                  </small>
                }
              </div>
            </div>
                    <div class="form-group col-6 px-md-4" [ngClass]="{'has-danger': form.get('user').get('user_company').touched &&
                     form.get('user').get('user_company').errors}">
              <label class="form-control-label" [ngClass]="{'required': true}" translate>Company Name</label>
              <input type="text" class="form-control" name="user_company" formControlName="user_company"
                            [ngClass]="{'form-control-danger': form.get('user').get('user_company').touched &&
                           form.get('user').get('user_company').errors}">
              <div aria-live="polite" role="log">
                @if (form.get('user').get('user_company').touched && form.get('user').get('user_company').errors) {
                  <small
                    class="form-control-feedback text-danger" translate>Please enter a valid company
                  </small>
                }
              </div>
            </div>
                    <div class="form-group col-6 px-md-4" [ngClass]="{'has-danger': form.get('user').get('user_country').touched &&
                     form.get('user').get('user_country').errors}">
              <label class="form-control-label" [ngClass]="{ 'required': true}" translate>Country
              {{searchText.value}}</label>
              <div>
                <mat-form-field floatLabel="never">
                  <mat-select disableOptionCentering #matSelect panelClass="select-panel"
                    [id]="'country-id'" [formControl]="form.get('user').get('user_country')"
                    placeholder="{{('Select option') | translate}}">
                    <mat-option><ngx-mat-select-search [hideClearSearchButton]="true"
                      [formControl]="searchText" [attr.aria-label]="'dropdown search'|translate"
                    placeholderLabel="{{'search..'| translate}}"></ngx-mat-select-search></mat-option>
                    @for (country of ((countries$ | async)?? []) | search:'title' :searchText.value: false; track country) {
                      <mat-option #option
                        [value]="country.value" [ngClass]="{'d-none': country['__hide']}">
                        {{country.title}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div aria-live="polite" role="log">
                @if (form.get('user').get('user_country').touched && form.get('user').get('user_country').errors) {
                  <small
                    class="form-control-feedback text-danger" translate>Please select a country
                  </small>
                }
              </div>
            </div>
                    <div class="form-group col-6 px-md-4" [ngClass]="{'has-danger': form.get('user').get('c_r1').touched &&
                     form.get('user').get('c_r1').errors}">
              <label class="form-control-label" [ngClass]="{ 'required': true}" translate>Segment</label>
              <select name="c_r1" formControlName="c_r1" class="form-control"
                            [ngClass]="{'form-control-danger': form.get('user').get('c_r1').touched &&
                                         form.get('user').get('c_r1').errors && form.get('user').get('c_r1').errors?.pattern}">
                <option value="" disabled selected hidden translate>Select option</option>
                @for (segment of ((segments$ | async)?? []); track segment) {
                  <option [ngValue]="segment.value">
                  {{segment.title}}</option>
                }
              </select>
              <div aria-live="polite" role="log">
                @if (form.get('user').get('c_r1').touched && form.get('user').get('c_r1').errors) {
                  <small
                    class="form-control-feedback text-danger" translate>Please select a segment
                  </small>
                }
              </div>
            </div>
            <!--                <div class="form-group col-12 col-md-6 px-md-4"-->
                    <!--                     [ngClass]="{'has-danger': form.get('user').get('c_r2').touched &&-->
                    <!--                 form.get('user').get('c_r2').errors}">-->
                    <!--                    <label class="form-control-label"  [ngClass]="{ 'required': true}" translate>Sub Segment</label>-->
                    <!--                    <select name="c_r2" formControlName="c_r2"-->
                    <!--                            class="form-control"-->
                    <!--                            [ngClass]="{'form-control-danger': form.get('user').get('c_r2').touched &&-->
                    <!--                                     form.get('user').get('c_r2').errors && form.get('user').get('c_r2').errors?.pattern}">-->
                    <!--                        <option value="" disabled selected hidden translate>Select option</option>-->
                    <!--                        <option *ngFor="let sub of ((subSegments$ | async)?? [])"-->
                    <!--                                [ngValue]="sub.value">{{sub.title}}</option>-->
                    <!--                    </select>-->
                    <!--                    <div aria-live="polite" role="log">-->
                    <!--                        <small *ngIf="form.get('user').get('c_r2').touched && form.get('user').get('c_r2').errors"-->
                    <!--                               class="form-control-feedback text-danger" translate>Please select a subSegment-->
                    <!--                        </small>-->
                    <!--                    </div>-->
                    <!--                </div>-->
                </ng-container>
}
                <div class="form-group col-6 px-md-4"
                    [ngClass]="{'has-danger': form.get('quantity').touched && form.get('quantity').errors}">
  <label class="form-control-label" [ngClass]="{'required': true}" translate>Quantity</label>
  <input type="text" class="form-control" name="quantity" formControlName="quantity"
    [ngClass]="{'form-control-danger': form.get('quantity').touched && form.get('quantity').errors, 'form-control-success': form.get('quantity').touched && form.get('quantity').valid}">
  <div aria-live="polite" role="log">
    @if (form.get('quantity').touched && form.get('quantity').errors ) {
      <small
        class="form-control-feedback text-danger" translate>Please enter a valid first name
      </small>
    }
  </div>
</div>
<div class="form-group col-6 px-md-4"
  [ngClass]="{'has-danger': form.get('unit').touched && form.get('unit').errors}">
  <label class="form-control-label" [ngClass]="{'required': true}" translate>Unit Or km</label>
  <div>
    <div class="form-check form-check-inline"
      [ngClass]="{'checked': form.get('unit').value == 'km'}">
      <input class="form-check-input" id="km" type="radio" value="km" formControlName="unit">
      <label class="form-check-label" translate>km</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" id="unit" type="radio" value="Unit" formControlName="unit">
      <label class="form-check-label" translate>Unit</label>
    </div>
  </div>
</div>
<div class="form-group col-12 px-md-4"
  [ngClass]="{'has-danger': form.get('comment').touched && form.get('comment').errors}">
  <label class="form-control-label" translate>Comment</label>
  <textarea class="form-control" name="comment" formControlName="comment"
  [ngClass]="{'form-control-danger': form.get('comment').touched && form.get('comment').errors, 'form-control-success': form.get('comment').touched && form.get('comment').valid}"></textarea>
</div>
@if (user.isGuest()) {
  <div class="form-group col-12 px-md-4" formGroupName="user">
    <mat-checkbox formControlName="newsletter" class="m-2"></mat-checkbox>
    <label class="form-control-label" translate>I agree to receive other communications from
    Teldor.</label>
  </div>
}
</div>
<div class="btn-hover-effect">
  <button type="submit" class="btn app-btn-registration btn-outline-secondary" spinEl
    [spinning]="submitSpinner" translate>
    Create RFQ
  </button>
</div>
<div class="form-group translate">
  <p class="small">You may unsubscribe from these communications at any time. For more information on how to
    unsubscribe, our privacy practices, and how we are committed to protecting and respecting your
    privacy, please review our <a href="/page/Privacy-Policy" title="Privacy-Policy"
    target="_blank"><strong><u>Privacy Policy</u></strong></a>. By clicking submit, you
    consent to allow teldor.com to store and process the personal information submitted above to
  provide you the content requested.</p>
  <p class="small">To learn more about what information we collect from you upon submitting this request, click <a
  href="/page/Privacy-Policy#CPRA" title="Privacy-Policy" target="_blank">here</a> to view the
  relevant clause in Teldor&rsquo;s Privacy Policy
</p>
</div>
</form>
} @else {
  <contentloader></contentloader>
}
</div>
